import { useCallback, useEffect, useState } from 'react';
import client, { mensajeDeError } from '../../api/client';
import Button from '../../components/ui/Button';
import Badge from '../../components/ui/Badge';
import Modal from '../../components/ui/Modal';
import Spinner from '../../components/ui/Spinner';
import { Campo, Etiqueta, Entrada, AreaTexto, MensajeError } from '../../components/ui/Form';
import { TituloSeccion, BarraAcciones, TablaEnvoltura, Tabla, CeldaAcciones, SinDatos } from './comunes';

const vacio = { nombre: '', especialidad: '', certificaciones: '', fotoUrl: '', activo: true };

function InstructoresAdmin() {
  const [instructores, setInstructores] = useState(null);
  const [editando, setEditando] = useState(null); // objeto en edición o `vacio`
  const [error, setError] = useState('');
  const [guardando, setGuardando] = useState(false);

  const cargar = useCallback(() => {
    client
      .get('/instructores', { params: { todos: '1' } })
      .then(({ data }) => setInstructores(data))
      .catch(() => setInstructores([]));
  }, []);

  useEffect(cargar, [cargar]);

  const abrir = (instructor) => {
    setError('');
    setEditando(
      instructor
        ? {
            id: instructor.id,
            nombre: instructor.nombre,
            especialidad: instructor.especialidad || '',
            certificaciones: instructor.certificaciones || '',
            fotoUrl: instructor.foto_url || '',
            activo: !!instructor.activo,
          }
        : { ...vacio }
    );
  };

  const guardar = async (e) => {
    e.preventDefault();
    setGuardando(true);
    setError('');
    try {
      if (editando.id) {
        await client.put(`/instructores/${editando.id}`, editando);
      } else {
        await client.post('/instructores', editando);
      }
      setEditando(null);
      cargar();
    } catch (err) {
      setError(mensajeDeError(err));
    } finally {
      setGuardando(false);
    }
  };

  const darDeBaja = async (id) => {
    try {
      await client.delete(`/instructores/${id}`);
      cargar();
    } catch (err) {
      setError(mensajeDeError(err));
    }
  };

  if (!instructores) return <Spinner />;

  const cambiar = (campo) => (e) => setEditando((d) => ({ ...d, [campo]: e.target.value }));

  return (
    <>
      <TituloSeccion>Instructores</TituloSeccion>
      <BarraAcciones>
        <Button onClick={() => abrir(null)}>Nuevo instructor</Button>
      </BarraAcciones>
      {error && !editando && <MensajeError role="alert">{error}</MensajeError>}
      <TablaEnvoltura>
        {instructores.length === 0 ? (
          <SinDatos>Sin instructores registrados.</SinDatos>
        ) : (
          <Tabla>
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Especialidad</th>
                <th>Estado</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {instructores.map((i) => (
                <tr key={i.id}>
                  <td>{i.nombre}</td>
                  <td>{i.especialidad || '—'}</td>
                  <td>
                    <Badge $tono={i.activo ? 'exito' : 'arena'}>{i.activo ? 'Activo' : 'Inactivo'}</Badge>
                  </td>
                  <CeldaAcciones>
                    <Button $variante="secundario" $chico onClick={() => abrir(i)}>
                      Editar
                    </Button>
                    {!!i.activo && (
                      <Button $variante="peligro" $chico onClick={() => darDeBaja(i.id)}>
                        Dar de baja
                      </Button>
                    )}
                  </CeldaAcciones>
                </tr>
              ))}
            </tbody>
          </Tabla>
        )}
      </TablaEnvoltura>

      <Modal
        abierto={!!editando}
        titulo={editando?.id ? 'Editar instructor' : 'Nuevo instructor'}
        onCerrar={() => setEditando(null)}
      >
        {editando && (
          <form onSubmit={guardar}>
            {error && <MensajeError role="alert">{error}</MensajeError>}
            <Campo>
              <Etiqueta htmlFor="i-nombre">Nombre</Etiqueta>
              <Entrada id="i-nombre" value={editando.nombre} onChange={cambiar('nombre')} required />
            </Campo>
            <Campo>
              <Etiqueta htmlFor="i-esp">Especialidad</Etiqueta>
              <Entrada id="i-esp" value={editando.especialidad} onChange={cambiar('especialidad')} />
            </Campo>
            <Campo>
              <Etiqueta htmlFor="i-cert">Certificaciones</Etiqueta>
              <AreaTexto id="i-cert" value={editando.certificaciones} onChange={cambiar('certificaciones')} />
            </Campo>
            <Campo>
              <Etiqueta htmlFor="i-foto">URL de foto (opcional)</Etiqueta>
              <Entrada id="i-foto" type="url" value={editando.fotoUrl} onChange={cambiar('fotoUrl')} />
            </Campo>
            {editando.id && (
              <Campo>
                <Etiqueta>
                  <input
                    type="checkbox"
                    checked={editando.activo}
                    onChange={(e) => setEditando((d) => ({ ...d, activo: e.target.checked }))}
                    style={{ marginRight: '0.5rem' }}
                  />
                  Activo
                </Etiqueta>
              </Campo>
            )}
            <Button type="submit" $completo disabled={guardando}>
              {guardando ? 'Guardando…' : 'Guardar'}
            </Button>
          </form>
        )}
      </Modal>
    </>
  );
}

export default InstructoresAdmin;
